import React from 'react'
import Box from '@mui/material/Box';
import EmploymentBanners from '../components/Employment/EmploymentBanners/EmploymentBanners'
import EmploymentRequests from '../components/Employment/EmploymentRequests/EmploymentRequests'
import ShareTabPanel from '../components/UI/Tab/Tab';

const Employment = () => {

  return (
    <Box sx={{ width: '100%' }}>
      <h3 style={{ textTransform: "capitalize" }}>Employment</h3>
      <ShareTabPanel tabs={[
        {
          key: 'Requests',
          label: 'Requests',
          children: <EmploymentRequests />
        },
        {
          key: 'Banners',
          label: 'Banners',
          children: <EmploymentBanners />
        },
      ]} />
    </Box>
  )
}

export default Employment